import { FC } from "react";

import EmptyGif from "@/assets/images/empty-markets.gif";
import FlexContainer from "@/components/FlexContainer";

import { StyledEmptyText, StyledWPEmptyMarketGif } from "./Styled";

interface EmptyMarketsProps {
    text: string;
}

export const EmptyMarkets: FC<EmptyMarketsProps> = ({ text }) => (
    <FlexContainer flexDirection="column" marginTop="16px" gap="16px">
        <StyledEmptyText>{text}</StyledEmptyText>
        <FlexContainer justifyContent="center">
            <StyledWPEmptyMarketGif src={EmptyGif} alt="empty markets" />
        </FlexContainer>
    </FlexContainer>
);
